import React from "react";
import { Button, Container, Nav } from 'react-bootstrap'
import Navbar from 'react-bootstrap/Navbar';



//FIXME: navbar toggle!!!
const Header = () => {

    return (

        <>
            <Navbar bg="primary" collapseOnSelect expand="lg" variant="dark">
                <Container>
                    <Navbar.Brand href="/">
                        Amigurumi Magia
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse className="justify-content-start" id="responsive-navbar-nav">
                        <Nav>
                            <Nav.Link href="/products" className="text-light">Produtos</Nav.Link>
                            <Nav.Link href="/about" className="text-light">Institucional</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                    <Navbar.Collapse className="justify-content-end">
                        <Nav>
                            <Button variant="light" href="/login" className="mr-2 mb-2 text-primary">Login</Button>
                            <Button variant="light" href="/register" className="mb-2 text-primary">Registrar-se</Button>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    )
}

//TODO: admin dashboard button (auth) | logado como ...

export default Header;